import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Component from './Component';
import ParentStyled from './style';
import { loadStyle } from 'globalutils/fmUtils';

const Styled = loadStyle(ParentStyled, 'pages/web/Vehicles/RoadsideInspections');

const RoadsideInspection = ({ apiStatus, history, callback, infoBlockItems, openDocumentApi, viewReport, ...rest }) => {
  return (
    <>
      <Component
        {...rest}
        history={history}
        infoBlockItems={infoBlockItems}
        apiStatus={apiStatus}
        callback={callback}
        openDocumentApi={openDocumentApi}
        viewReport={viewReport}
        Styled={Styled}
      />
    </>
  );
};

const mapState = (state) => {
  return {
    apiStatus: state.asyncRequests,
    infoBlockItems: state.vehicles.infoBlockItemsFilteredList,
    logBook: state.logBook,
  };
};

const mapDispatch = (dispatch) => {
  return {
    viewReport: (data) => dispatch.roadsideInspection.viewReport(data),
  };
};

export default connect(mapState, mapDispatch)(RoadsideInspection);

RoadsideInspection.propTypes = {
  callback: PropTypes.func.isRequired,
  infoBlockItems: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  apiStatus: PropTypes.object.isRequired,
};
